import {cx} from "emotion";
import * as React from "react";

import "./controls.scss";

import {cs}             from "@Common/react/chain-services";
import {TimeoutAction}  from "@Common/react/timeout-action";
import {UseState}       from "@Common/react/use-state";
import {SaveAlerts}     from "../../../common/SaveAlerts";

export const Controls = ({cc, itemSaver}) => cs(
    ["saveConfirmedAlert", (_, next) => UseState({next})],
    ["submitting", (_, next) => UseState({
        initValue: false,
        next,
    })],

    ({saveConfirmedAlert, submitting}) => (
        cc.sides?.length > 1 ? <div className="controls controls-283">
            <div className="buttons">
                {cc.sides?.map((sideName, i) => (
                    <button
                        key={i}
                        disabled={submitting.value}
                        className={cx(sideName === cc.currentSide && "selected")}
                        onClick={async () => {
                            submitting.onChange(true)
                            if (cc.changed) {
                                const saved = await cc.save();
                                itemSaver.save();
                                if (saved) {
                                    saveConfirmedAlert.onChange({
                                        heading: "CHANGES AUTO SAVED",
                                        message: "All of your changes have been saved",
                                        success: true,
                                    });
                                } else {
                                    saveConfirmedAlert.onChange({
                                        heading: "AUTO-SAVE INCOMPLETE",
                                        message: "Saving has not been completed. Please check your internet connection and Save again",
                                        success: false,
                                    });
                                }
                            }
                            cc.changeSide(i, cc.editing)
                            submitting.onChange(false);
                        }}
                        xd-qa-type="button"
                        xd-qa-name={sideName}
                    >
                        {sideName}
                    </button>
                ))}
                {saveConfirmedAlert.value && <>
                    {SaveAlerts({
                        message: saveConfirmedAlert.value,
                        onClose: () => saveConfirmedAlert.onChange(null),
                    })}

                    {saveConfirmedAlert.value.success && TimeoutAction({
                        delay: 4000,
                        action: () => saveConfirmedAlert.onChange(null),
                    })}
                </>}
            </div>
        </div> : <></>
    )
);